import { Link } from 'react-router-dom';

const rewards = [
  {
    level: '每日冠军',
    prize: '500元 + 金牌',
    color: 'bg-accent-100 text-accent-700 border-accent-300',
    icon: 'ri-medal-line',
  },
  {
    level: '周冠军',
    prize: '2000元 + 3000积分',
    color: 'bg-primary-100 text-primary-700 border-primary-300',
    icon: 'ri-trophy-line',
  },
  {
    level: '月度王者',
    prize: 'iPhone + 5000元',
    color: 'bg-secondary-100 text-secondary-700 border-secondary-300',
    icon: 'ri-vip-crown-line',
  },
  {
    level: '年度总冠军',
    prize: '10万元现金大奖',
    color: 'bg-foreground-100 text-foreground-700 border-foreground-300',
    icon: 'ri-star-line',
  },
];

export default function RewardsPreview() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            丰厚奖励等你来拿
          </h2>
          <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
            多层次奖励体系，从日奖到年度大奖，参赛就有机会赢取
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {rewards.map((reward) => (
            <div
              key={reward.level}
              className="p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all"
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-xl border mb-4 ${reward.color}`}
              >
                <i className={`${reward.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">
                {reward.level}
              </h3>
              <p className="text-sm text-foreground-600 mb-4">{reward.prize}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/reward-info"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看完整奖励体系
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}